document.addEventListener("DOMContentLoaded", (event) => {
  new Swiper(".cBlockProducts", {
    slidesPerView: "auto",
    freeMode: true,
    grabCursor: true,
    touchEventsTarget: "container",
    touchReleaseOnEdges: true,
    watchOverflow: true,
    navigation: {
      nextEl: ".cBlockProducts .cBlockSlider-right",
      disabledClass: "opacity-0",
    },
  });
});
